/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { AttributesSrcEntrypointProps } from './DataManagerAttributesPage.entrypoint.types.tsx';

type DataManagerAttributesEntryPointComponent = EntryPointComponent<
	{},
	{},
	AttributesSrcEntrypointProps,
	{}
>;

export const dataManagerAttributesEntryPoint: EntryPoint<
	DataManagerAttributesEntryPointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction<DataManagerAttributesEntryPointComponent>(
		/* webpackChunkName: "async-data-manager-attributes-page" */ './DataManagerAttributesPage.tsx',
	),
	getPreloadProps: () => ({
		extraProps: {},
	}),
});
